import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import muiAutocompleteInputLabelModuleCss from '../../../assets/css/mui.autocomplete.input-label.module.css';
import muiAutocompleteInputModuleCss from '../../../assets/css/mui.autocomplete.input.module.css';
import muiAutocompleteModuleCss from '../../../assets/css/mui.autocomplete.module.css';
import AdornmentState from './AdornmentState';
import InputEvents from './InputEvents';
import StringUtil from '../../../app/util/StringUtil';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';


type Param = {
    onInputChange: (value: string) => void,
    onInputBlur: (event: React.FocusEvent<HTMLInputElement>) => void,
    // Soll die blur()-Funktion beim Drücken von ENTER aufgerufen werden?
    blurOnEnter?: boolean | false
    preventSubmitOnEnter?: boolean | true,
    value?: string,
    options: string[]
    label?: string,
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number
    required?: boolean,
    error?: boolean,
    helperText?: string,
}

const AutocompleteField: React.FC<Param> = ({ onInputBlur, onInputChange, blurOnEnter, preventSubmitOnEnter = true, value, options, label, id, idGtm, idGtmIndex, required, error, helperText }) => {

    /*
    ***********************
    Autocomplete Props:
    ***********************
    freeSolo:
    If true, the Autocomplete is free solo, 
    meaning that the user input is not bound to provided options.

    debug:
    If true, the popup will ignore the blur event if the input is filled. 
    You can inspect the popup markup with your browser tools. 
    Consider this option when you need to customize the component.

    */

    const handleOnChange = (value: string) => {
        const newValue = StringUtil.replaceCrossSiteScripting(value);
        onInputChange(newValue || '');
    }

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    const onKeyPressEnter = (event: any) => {
        if (preventSubmitOnEnter === true) {
            InputEvents.preventOnKeyPressEnter(event);
        }
        if (blurOnEnter === true && (event.key === 'Enter')) {
            if (onInputBlur !== undefined) {
                onInputBlur(event);
            }
        }
    }

    return (

        <Autocomplete
            id={id}
            options={options}
            getOptionLabel={(option) => {/*
                console.log('***************************getOptionLabel-typeof', typeof option, option);
                if (typeof option === 'string') {
                    console.log('return1', option);
                    return Hunderassen[0].rasse;
                }

                console.log('return2', option.rasse);
                */
                return option;
                //return option.rasse;
            }}
            disableClearable
            classes={muiAutocompleteModuleCss}
            debug={false}
            inputValue={value}
            fullWidth={true}
            freeSolo={true}
            onChange={(event: any, option: any | null) => {
                handleOnChange(option)
            }}

            renderInput={(params) =>
                <TextField {...params}
                    label={label}
                    required={required}
                    error={error}
                    helperText={helperText}
                    onFocus={handleOnFocus}
                    onChange={event => handleOnChange(event.target.value)}
                    onBlur={onInputBlur}
                    onKeyPress={onKeyPressEnter}
                    InputProps={{
                        ...params.InputProps,
                        classes: muiAutocompleteInputModuleCss,
                        endAdornment: <AdornmentState error={error} />
                    }}

                    InputLabelProps={{
                        ...params.InputLabelProps,
                        classes: muiAutocompleteInputLabelModuleCss,
                        shrink: value ? true : undefined,
                    }}
                />
            }
        />


    );
}

export default AutocompleteField;